export enum BOOK_INVITE_ACTION_OPERATION {
    list = 'list',
    create = 'create',
    resend = 'resend',
    copyLink = 'copyLink',
    cancel = 'cancel',
}
